import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'localizedQuantity',
})
export class LocalizedQuantityPipe implements PipeTransform {
  constructor(@Inject(TranslateService) private translateService: TranslateService) {
  }

  transform(value: number, type): unknown {
    let lang = this.translateService.currentLang;
    if (lang.toLowerCase() === 'gb') {
      lang = 'en';
    }
    let suffix = '';
    if (type.toLowerCase().startsWith('package_')) {
      type = type.toLowerCase().replace('package_', '');
      suffix = ' ' + this.translateService.instant('global.common.package');
    }
    const finalType = type.toLowerCase() === 'days' || type.toLowerCase() === 'day' ? 'day' : 'hour';
    if (0 === value) {
      return '0 ' + this.translateService.instant('global.common.' + finalType + (lang === 'en' ? 's' : '')) + suffix;
    } else if (value > 0 && value <= 1) {
      return value + ' ' + this.translateService.instant('global.common.' + finalType) + suffix;
    }
    return value + ' ' + this.translateService.instant('global.common.' + finalType + 's') + suffix;
  }
}
